import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { BBResponseContainer } from "../carrier/response-container";
import { LabMDM } from '../masterdata/models/lab';
import { tap, timeout } from 'rxjs/operators';

/**
 * @description Angular Service to interact with Sequencing service
 * to get a container status based on container barcode and robot.
 */
@Injectable()
export class StepSequenceService {

    constructor(private http: HttpClient) {
    }

     /**
     * @description generate sequencer control file for given container barcode.
     */
    public generateControlFile(containerBarcode: string, lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_SEQUENCING_SERVICE_URL + 'contianer/status/generateControllerFile';
        let requestParam = new HttpParams().set('containerBarcode', containerBarcode)
            .set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

}